import type { StorageAdapter } from '@/services/storage/storage-adapter';
import type { Waypoint, CreateWaypointInput, UpdateWaypointInput } from '@/types/waypoint';
import { WaypointType } from '@/types/waypoint';
import { recordPendingDelete } from './sync-service';
import { posthogService } from '@/services/posthog-service';
import { EVENT_LOCATION_CREATED } from '@/services/observability/events';

export class WaypointService {
  constructor(private adapter: StorageAdapter) {}

  async getWaypoints(propertyId: string): Promise<Waypoint[]> {
    return this.adapter.getWaypoints(propertyId);
  }

  async getWaypoint(id: string): Promise<Waypoint | null> {
    return this.adapter.getWaypoint(id);
  }

  async getWaypointsByType(propertyId: string, type: WaypointType): Promise<Waypoint[]> {
    return this.adapter.getWaypointsByType(propertyId, type);
  }

  async createWaypoint(data: CreateWaypointInput): Promise<Waypoint> {
    const waypoint = await this.adapter.createWaypoint(data);
    posthogService.track(EVENT_LOCATION_CREATED, { type: data.type });
    return waypoint;
  }

  async updateWaypoint(id: string, data: UpdateWaypointInput): Promise<Waypoint> {
    return this.adapter.updateWaypoint(id, data);
  }

  async deleteWaypoint(id: string): Promise<void> {
    await this.adapter.deleteWaypoint(id);
    await recordPendingDelete(id, 'waypoint');
  }
}
